import lang from '../../lib/language';

export const renderTitle = (
  isAutoPassPayment: boolean,
  isActivatingAutoPass:boolean,
  showActivatedAutoPassModal:boolean,
  showFailedAutoPassModal?: boolean,
) => {
  if (isActivatingAutoPass) {
    if (showFailedAutoPassModal) {
      return lang.autoPassActivationFailedTitle();
    }
    return showActivatedAutoPassModal ? lang.autoPassActivated() : lang.wantToActivateAutoPass();
  }
  return isAutoPassPayment ? lang.autoPassDeactivated() : lang.deactivateAutoPassModalTitle();
};

export const renderText = (
  isAutoPassPayment: boolean,
  isActivatingAutoPass:boolean,
  showActivatedAutoPassModal:boolean,
) => {
  if (isActivatingAutoPass) {
    return showActivatedAutoPassModal
      ? lang.automaticTransitionEnabled() : lang.automaticTransitionText();
  }
  return isAutoPassPayment ? lang.reactivateAutoPassText() : lang.deactivateAutoPassModalDescription();
};
